<template>
    <div>
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-title">
                    <h3>Detalhe Receita: {{ recipe.name }} ({{ recipe.recipe_id }})</h3>
                    <h4>Categoria: {{ (recipe.category) ? recipe.category.description : '' }}</h4>
                </div>
            </div>
            <div class="panel-body">
                <form id="form">
                    <div class="row">
                        <div class="col-md-12">
                            <img :src="recipe.photo" alt="Sem Foto" class="img-responsive img-thumbnail">

                            <hr>
                            <h4>Ingredientes</h4>
                            <table class="table table-bordered table-condensed">
                                <thead>
                                </thead>
                                <tbody>

                                <template v-for="sequence in ingredientSequences">

                                    <tr class="success">
                                        <td colspan="2">
                                            <b>{{sequence}}</b>
                                        </td>
                                    </tr>

                                    <tr class="info">
                                        <td><b>Ingrediente</b></td>
                                        <td><b>Quantidade</b></td>
                                    </tr>

                                    <tr v-for="ingredient in recipe.ingredients"
                                        v-if="ingredient.part_name == sequence">

                                        <td>{{ingredient.quantity}} {{ingredient.unit}}</td>

                                        <td v-if="ingredient.product != undefined">
                                            <router-link :to="'/product/view/' + ingredient.product.id">
                                                {{ingredient.product.name}}
                                            </router-link>
                                        </td>

                                        <td v-if="ingredient.ingredient != undefined">{{ingredient.ingredient.name}}
                                        </td>
                                    </tr>

                                </template>
                                </tbody>
                            </table>

                            <h4>Adicionados a Gosto</h4>
                            <p>{{recipe.to_taste}}</p>
                            <br>
                            <br>

                            <h4>Modo de Fazer</h4>
                            <p v-html="recipe.process"></p>

                            <h4>Dicas Técnicas</h4>
                            <p v-html="recipe.hints"></p>
                            <br>
                            <h4>Rendimento</h4>
                            {{recipe.yield}} / {{recipe.loss}}%
                            <br>
                            <br>
                            <h4>Validade</h4>
                            {{recipe.shelf_life}} horas

                            <br>
                            <br>
                            <h4>Equipamentos</h4>
                            <p>
                                <span v-for="equipment in recipe.equipments">
                                  {{equipment.equipment.description}},
                                </span>
                            </p>

                            <br>
                            <br>

                            <h4>Tabela Nutricional</h4>
                            <table class="table table-bordered table-striped">
                                <tbody>
                                <tr v-for="(nutrition,index) in recipe.nutritions">
                                    <td v-if="index == 0">{{nutrition.portion}}</td>
                                    <td v-if="index == 0"></td>
                                    <td v-if="index == 0">% VD (*)</td>

                                    <td v-if="index != 0">{{nutrition.description}}</td>
                                    <td v-if="index != 0">{{nutrition.value}}</td>
                                    <td v-if="index != 0">{{nutrition.percentage}}</td>
                                </tr>
                                </tbody>
                            </table>

                            <p>
                                * % Valores diários com base em uma dieta de 2.000 kcal ou 8400 kJ. Seus valores diários
                                podem ser maiores ou menores, dependendo das suas necessidades energéticas.</p>
                            <p>** %VD Não estabelecido.</p>
                        </div>
                    </div>

                    <router-link to="/recipe" class="btn btn-info">Voltar</router-link>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                recipe: {
                    category: {
                        description: ''
                    }
                },
                sequence: 0
            }
        },
        props: {},
        computed: {
            ingredientSequences() {
                return this.recipe.ingredients.map(function (ingredient) {
                    return ingredient.part_name
                }).filter(function (el, index, self) {
                    return self.indexOf(el) === index
                })
            }
        },
        created: function () {
            const self = this;
            const id   = self.$route.params.id;
            const api  = self.$store.state.api;

            self.$http.get(api + 'recipe/' + id + '?disabled=true')
                .then((response) => {
                    self.recipe = response.data;
                })
                .catch((error) => {
                    self.$message(null, 'Ocorreu um erro ao buscar as informacões da Receita');
                });

        },
        methods: {
            setPart(sequence) {
                this.sequence = sequence
            }

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/Recipe/View.vue